module.exports = __webpack_public_path__ + "static/media/successIcon.bec7cc4f.svg";